export default __webpack_public_path__ + "static/media/hht1_ani_14.5c0a6196.png";